export enum ModalFunctionType {
  TOOLTIP = 'tooltip',
  TOOLTIP_REVERSE = 'tooltip_reverse',
  LIST = 'list',
  VIDEO = 'video',
  VIDEO_HEADER_STAGE = 'video_header_stage',
  EXPAND = 'expand',
}
